import React, { useEffect, useState } from 'react';
import { ButtonGroup, Table, UncontrolledTooltip } from 'reactstrap';
import ListTableRow from 'components/Table/ListTableRow';
import { Eye } from 'react-feather';
import { formatHHmmDDMMYYYY } from 'helpers/format-time';
import styles from 'styles/Course.module.scss';
import FooterTableCustom from 'components/Table/FooterTableCustom';
import unitsApi from 'api/unitsApi';
import classnames from 'classnames';
import ModalHistory from 'modules/Course/Submissions/ModalHistory';
import { INIT_DATA } from '../../../../../../../constants/default';
import { useUnit } from 'hooks/units/index';
import { useRouter } from 'next/router';
import {
  LIMIT_GET_LIST,
  UNIT_TYPE,
  USER_ROLES,
  USER_STATUS,
} from 'constants/constants';
import { downloadFile, handleToastError } from 'helpers/index';
import useI18n from 'hooks/use-i18n';
import { getViewMode } from 'store/auth';
import { useDispatch, useSelector } from 'react-redux';
import unitCourseApi from 'api/unitCourseApi';
import { resetUnitAsync } from 'store/units';
import { getSelectedCentre } from 'store/master';
import { MdSystemUpdateAlt } from 'react-icons/md';
import { Tooltip } from 'antd';
import { LearnerAnswer } from './TrackingResultAssignment';
const TrackingResultNew = (props) => {
  const i18n = useI18n();
  const router = useRouter();
  const { isBusy, type } = props;
  const [resultTracking, setResultTracking] = useState(INIT_DATA);
  const { query } = useRouter();
  const viewMode = useSelector(getViewMode);
  const dispatch = useDispatch();
  const unitSelected = useUnit();
  const selectedCentre = useSelector(getSelectedCentre);
  const [selectedHistory, setSelectedHistory] = useState({
    history: false,
    lastUpdate: false,
  });
  async function getTrackingResult(page = 1, text = '') {
    try {
      if (query?.unitId) {
        const params = {
          id: query?.unitId,
          page,
          limit: LIMIT_GET_LIST,
          isResultPage: true,
        };
        const response = await unitsApi.getSubmissions(params);
        setResultTracking(response);
      }
    } catch (error) {
      handleToastError(error, i18n);
    }
  }

  async function downLoadFile(file) {
    try {
      await downloadFile(file?.path, file?.originalname);
    } catch (error) {}
  }

  const checkStatus = async () => {
    try {
      getTrackingResult();
      const response = await unitCourseApi.getUnit({ id: query?.unitId });
      let param = {};
      if (selectedCentre?._id) {
        param.centreId = selectedCentre?._id;
      }
      if (
        selectedCentre?.reviewContent ||
        selectedCentre?.reviewContent === undefined
      ) {
        param.reviewContent = true;
      }
      !response.hasOwnProperty('results') &&
        dispatch(resetUnitAsync(unitSelected?._id, query?.slug, param));
    } catch (e) {
      handleToastError(e);
    }
  };

  const thead = [
    {
      param: '',
      name: ' Users',
      style: { width: 200, textAlign: 'left' },
    },
    {
      param: '',
      name: 'Date & Time of submission',
      style: { width: 350, textAlign: 'center' },
    },

    {
      param: '',
      name: 'Actions',
      style: {
        width: 200,
        textAlign: 'center',
      },
    },
  ];
  useEffect(() => {
    getTrackingResult();
  }, [unitSelected]);
  return (
    <div className="overflow-x-auto mt-1">
      <Table className="table-header-custom" responsive>
        <thead>
          <tr>
            {thead.map((item) => (
              <th
                key={item.name}
                style={item.style || {}}
                className={'cursor-pointer'}
              >
                {item.name}
                {item.param && (
                  <span>
                    <ChevronDown size={16} />
                  </span>
                )}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          <ListTableRow
            isBusy={isBusy}
            col={6}
            length={resultTracking?.data?.length}
          >
            {resultTracking?.data?.map(
              (users, index) =>
                users?.status !== USER_STATUS.DELETED &&
                (viewMode == USER_ROLES.LEARNER ? (
                  <tr
                    key={index}
                    className={classnames(
                      'cursor-pointer',
                      users?.status === 'DELETED'
                        ? 'tracking-data-delete'
                        : null,
                      styles[
                        users?.status === 'DELETED'
                          ? 'tracking-data-delete'
                          : null
                      ],
                    )}
                    onClick={() => {
                      if (users?.status !== 'DELETED') {
                        setSelectedHistory((preVal) => ({
                          ...preVal,
                          history: users,
                        }));
                      }
                    }}
                  >
                    <td className="text-left bold">
                      {users?.user[0]?.fullName}
                    </td>
                    <td className="text-center">
                      {formatHHmmDDMMYYYY(
                        viewMode === USER_ROLES.LEARNER
                          ? users?.updatedAt
                          : item?.user[0]?.userUnits[0]?.updatedAt,
                      )}
                    </td>

                    <td className="text-center pl-0">
                      <ButtonGroup className="mb-1 ">
                        <span
                          style={{
                            cursor:
                              users?.status !== 'DELETED'
                                ? 'cursor-pointer'
                                : 'no-cursor',
                          }}
                          id={`id-view-${users?._id}${index}`}
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelectedHistory((preVal) => ({
                              ...preVal,
                              history: users,
                            }));
                          }}
                        >
                          <Eye size={15} style={{ marginLeft: '1.5rem' }} />
                          {users?.status !== 'DELETED' && (
                            <UncontrolledTooltip
                              placement="top"
                              className="d-md-block d-none"
                              target={`id-view-${users?._id}${index}`}
                            >
                              History
                            </UncontrolledTooltip>
                          )}
                        </span>
                      </ButtonGroup>
                    </td>
                  </tr>
                ) : (
                  users?.user?.map((item, index) =>
                    item?.userUnits && item?.userUnits.length ? (
                      <tr
                        key={index}
                        className={classnames(
                          'cursor-pointer',
                          item?.status === USER_STATUS.DELETED
                            ? 'tracking-data-delete'
                            : null,
                          styles[
                            item?.status === USER_STATUS.DELETED
                              ? 'tracking-data-delete'
                              : null
                          ],
                        )}
                        onClick={() => {
                          if (
                            item?.status !== USER_STATUS.DELETED &&
                            item?.userUnits?.[0]
                          ) {
                            setSelectedHistory((preVal) => ({
                              ...preVal,
                              history: item?.userUnits[0],
                            }));
                          }
                        }}
                      >
                        <td className="text-left bold">{item?.fullName}</td>
                        <td className="text-center">
                          {formatHHmmDDMMYYYY(item?.userUnits[0]?.updatedAt)}
                        </td>

                        <td className="text-center px-0">
                          <ButtonGroup className=" d-flex align-items-center justify-content-center">
                            <Tooltip title="History">
                              <Eye
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setSelectedHistory((preVal) => ({
                                    ...preVal,
                                    history: item?.userUnits[0],
                                  }));
                                }}
                                size={15}
                              />
                            </Tooltip>

                            {type !== UNIT_TYPE.TEST ? (
                              <Tooltip title="Last Update">
                                <MdSystemUpdateAlt
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setSelectedHistory((preVal) => ({
                                      ...preVal,
                                      lastUpdate: item?.userUnits[0],
                                    }));
                                  }}
                                  size={15}
                                  className="ml-1"
                                />
                              </Tooltip>
                            ) : null}
                          </ButtonGroup>
                        </td>
                      </tr>
                    ) : null,
                  )
                )),
            )}
          </ListTableRow>
        </tbody>
      </Table>
      <FooterTableCustom
        pageCount={resultTracking?.totalPage}
        currentPage={resultTracking?.currentPage}
        currentItem={resultTracking?.data?.length}
        totalItems={resultTracking?.totalItems}
        showInputSearch={false}
        onChange={getTrackingResult}
        preventFirstLoad
      />
      {selectedHistory.history && (
        <ModalHistory
          open={!!selectedHistory.history?._id}
          toggle={() =>
            setSelectedHistory((preVal) => ({ ...preVal, history: false }))
          }
          submission={selectedHistory.history}
          getSubmissions={checkStatus}
          type={type}
        />
      )}
      {selectedHistory.lastUpdate ? (
        <LearnerAnswer
          isBusy={isBusy}
          selected={{
            ...selectedHistory.lastUpdate,
            result: {
              ...selectedHistory.lastUpdate.result,
              file: selectedHistory.lastUpdate.files,
            },
          }}
          toggle={() =>
            setSelectedHistory((preVal) => ({ ...preVal, lastUpdate: false }))
          }
          downLoadFile={downLoadFile}
          isLazyLoad={false}
        />
      ) : null}
    </div>
  );
};

export default TrackingResultNew;
